import { ToastrService } from 'ngx-toastr';
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { AuthenticationService } from "../_services/authentication.service";
import {Permission} from "./Permission";

@Injectable({ providedIn: 'root' })
  //TODO:cambiare con capacita
export class AuthGuardAmministrazione implements CanActivate {
  constructor(
    private permission: Permission,
    private router: Router,
    private authenticationService: AuthenticationService,
    private toastrService: ToastrService
  ) {}
  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this.authenticationService.currentUserValue;
    if (currentUser && (this.permission.isPermitted("menu-persone") || this.permission.isPermitted("menu-clienti"))) {
        // authorised so return true
        return true;
    }
    // not logged in so redirect to login page with the return url
    this.toastrService.error('Non hai i permessi per accedere a questo contenuto.','Ooops')
    this.router.navigate(['/Login'], { queryParams: { returnUrl: state.url }});
    return false;
  }
}
